/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Share: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="share" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M170 736.6666666666667A113.3333333333333 113.3333333333333 0 0 0 283.3333333333333 850H453.3333333333333V736.6666666666667H283.3333333333333V283.3333333333335H1076.6666666666665V736.6666666666667H906.6666666666666V850H1076.6666666666665A113.3333333333333 113.3333333333333 0 0 0 1190 736.6666666666667V283.3333333333335A113.3333333333333 113.3333333333333 0 0 0 1076.6666666666665 170H170V736.6666666666667zM998.75 1064.2566666666667L927.9166666666666 975.7433333333335L736.6666666666666 1128.7433333333333V453.3333333333334H623.3333333333333V1128.7433333333333L432.0833333333333 975.7433333333335L361.25 1064.2566666666667L680 1319.2566666666667L998.75 1064.2566666666667z" : "M136 589.3333333333333A90.6666666666667 90.6666666666667 0 0 0 226.6666666666667 680H362.6666666666667V589.3333333333333H226.6666666666667V226.6666666666667H861.3333333333334V589.3333333333333H725.3333333333334V680H861.3333333333334A90.6666666666667 90.6666666666667 0 0 0 952 589.3333333333333V226.6666666666667A90.6666666666667 90.6666666666667 0 0 0 861.3333333333334 136H136V589.3333333333333zM799 851.4053333333334L742.3333333333334 780.5946666666666L589.3333333333334 902.9946666666666V362.6666666666667H498.6666666666667V902.9946666666666L345.6666666666667 780.5946666666666L289 851.4053333333334L544 1055.4053333333334L799 851.4053333333334z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Share.displayName = `Blueprint5.Icon.Share`;
export default Share;
